import {
  type DataBindingControllerConnection,
  type DataBindingControllerConnectionWithRole,
  type DataBindingRole,
} from '../types'

export const isControllerConnectionWithRole = <Role extends DataBindingRole>(
  connection: DataBindingControllerConnection,
  role: Role,
): connection is DataBindingControllerConnectionWithRole<Role> => {
  return connection.role === role
}
